import imageCompression from "browser-image-compression";
import React, { useEffect, useRef, useState } from "react";
import { FaChevronDown, FaChevronUp, FaLeaf, FaPlus } from "react-icons/fa";
import Stepper from "react-stepper-horizontal"; // Import Stepper
import useApiFetcher from "../../hooks/useApiFetcher";
import styles from "./StepperForm.module.css";
import TableComponent from "./TableComponent";
import * as pdfjsLib from "pdfjs-dist/webpack";
import { TailSpin } from 'react-loader-spinner';
import { motion, AnimatePresence } from "framer-motion"
import { ChevronRightIcon } from "@heroicons/react/24/solid"
import { useTheme } from "../BrandColors/Context/ThemeContext";

import {
  ClipboardIcon,
  ScissorsIcon,
  DocumentDuplicateIcon,
  ArrowUturnLeftIcon,
  ArrowUturnRightIcon,
  TrashIcon,
} from "@heroicons/react/24/outline"

import axios from "axios";
import { FaEdit } from "react-icons/fa";
import { GrFormPrevious } from "react-icons/gr";
import { MdDelete, MdNavigateNext } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { updatemultiStepProcessId } from "../../Redux/authSlice";
import { savemultiStepProcessId } from "../Avatar/Utility";

const categories = [
  "Intro",
  "Intro1",
  "Product Script",
  "Summary Script",
  "Final Script",
];

const StepperForm = () => {
  const delaershipTheme = useTheme()

  const dispatch = useDispatch();
  const { apiFetcher } = useApiFetcher();
  const multiStepProcessId = useSelector((state) => state.auth.multiStepProcessId)
  const [currentStep, setCurrentStep] = useState(1);
  const [steps, setSteps] = useState([]); //{ number: prev.length + 1, title: "New Step", script: "", submitted: false },
  const [activeIndex, setActiveIndex] = useState(null);
  // const [sentences, setSentences] = useState([]);
  const [promptInput, setPromptInput] = useState(""); // Shared prompt text
  const [tableIndex, setTableIndex] = useState(null);
  // const [tableData, setTableData] = useState(data); // State to manage table data
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSentence, setSelectedSentence] = useState(null);
  const [editIndex, setEditIndex] = useState(null); // To track the index being edited
  const user = JSON.parse(localStorage.getItem("user"));
  // const [price, setPrice] = useState("");
  // const [priceTax, setPriceTax] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isYes, setIsYes] = useState(false);
  const [resp, setResp] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  console.log('selectedImage', selectedImage)
  const token = useSelector((state) => state.auth.token);
  const [editing, Setediting] = useState(false)
  // const [formData, setFormData] = useState([]);
  const [submitting, setSubmitting] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(null);
  const [discountPercent, setDiscountPercent] = useState(0);
  const [buttonText, setButtonText] = useState("");
  const [formData, setFormData] = useState({
    selectedSentence: selectedSentence,
    heading: "",
    subHeading: "",
    content: "",
    category: "",
    isButton: false,
    buttonText: "",
    unselectionScrip: "",
    reselectionScrip: "",
    images: [
      {
        imgTitle: "",
        image: null, // For single or multiple images
      },
    ],
  });
  const lastStepref = useRef(1)
  const [editingIndex, setEditingIndex] = useState(null);
  const [originalStepData, setOriginalStepData] = useState(null);
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    index: null,
  });

  console.log(editing, "editing")
  console.log(isYes, "isYes")

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await apiFetcher(`/multi-stepper/${user?.multiStepProcessId}`, "GET");
        console.log("RESP", response)
        if (response) {
          const newSteps = response.steps.map((step, index) => {
            const script = step.script || "";
            setPromptInput(step.aiPrompt)
            const otherdata = {
              category: step.type,
              number: index + 1,
              reSelectionScript: step.reSelection || "",
              script: step.script || "",
              submitted: true,
              title: step.stepTitle || `Step ${index + 1}`,
              unselectionScript: step.unSelection || "",
              price: step.price,
              priceTax: step.priceTax,
              discountPercent: step.discountPercent,
              buttonText: step.buttonText
            }
            const newSentences = splitSentences(script)
              .filter((sentence) => sentence.trim() !== "")
              .map((sentence) => {
                const matchedNotepadContent = step.notepadContents?.find((notepad) =>
                  notepad.key.trim() === sentence.trim()
                )

                return {
                  sentence: sentence.trim(),
                  notepadData: {
                    selectedSentence: matchedNotepadContent?.key || "",
                    heading: matchedNotepadContent?.heading || "",
                    subHeading: matchedNotepadContent?.subHeading || "",
                    content: matchedNotepadContent?.sentence || "",
                    category: matchedNotepadContent?.category || "",
                    isButton: matchedNotepadContent?.isButton || false,
                    buttonText: matchedNotepadContent?.buttonText || "",
                    unselectionScrip: matchedNotepadContent?.unselectionScrip || "",
                    reselectionScrip: matchedNotepadContent?.reselectionScrip || "",
                    images: matchedNotepadContent?.images?.map(({ text, image }) => ({
                      imgTitle: text || "",
                      image: image || null, // Handle null values for images
                    })) || [],
                  },
                  boardDataAdded: matchedNotepadContent?.boardDataAdded || false
                };
              });

            return {
              boardData: newSentences,
              ...otherdata
            };
          });
          setResp(response)
          setSteps(newSteps);
          setPromptInput(response.aiPrompt || "");
        }
      } catch (error) {
        console.error("Error fetching saved data:", error);
      } finally {
        setIsLoading(false); // Hide loader when fetching completes
      }
    };
    if (user?.multiStepProcessId?.length) {
      fetchData();
    }
  }, [multiStepProcessId]);

  useEffect(() => {
    setPromptInput(resp.aiPrompt || "");

  }, [currentStep]);
  useEffect(() => {
    setFormData((prevformdata) => {
      return {
        ...prevformdata,
        selectedSentence: selectedSentence,
      };
    });
  }, [selectedSentence]);
  console.log(promptInput, 'pmoyy')

  const handleNextStep = () => {
    // if (currentStep === 1) {
    //   // const preFilledPrompt = generatePreFilledPrompt();
    //   setPromptInput();
    // }

    for (let tableIndex = 0; tableIndex < steps.length; tableIndex++) {
      const tableData = steps[tableIndex]?.boardData;
      console.log(steps[tableIndex].category, "LLL")
      if (tableData && tableData.length > 0) {
        const lastSentence = tableData[tableData.length - 1]; // Get the last sentence
        if (["Summary Script", "Final Script"].includes(steps[tableIndex]?.category)) {
          continue;
        }
        // if (!lastSentence?.notepadData?.buttonText || lastSentence.notepadData.buttonText.trim() === "") {
        //   alert(`Please add Button Text for the last sentence in Table of ${steps[tableIndex].title} before adding a new step.`);
        //   return;
        // }
      }
    }


    setCurrentStep((prev) => prev + 1);
    console.log("STEPS", steps)
  };
  const handlePrevStep = () => setCurrentStep((prev) => prev - 1);
  useEffect(() => {
    window.addEventListener("beforeunload", handleWindowClose);
    return () => {
      window.removeEventListener("beforeunload", handleWindowClose);
    };
  }, []);
  const handleWindowClose = (event) => {
    console.log("User is trying to refresh or close the window");
    event.preventDefault();
  };

  // Step 1: StepperForm Logic

  const [isShowNext, setIsShowNext] = useState(false);
  const handleImageChange = async (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    // Compression options
    const options = {
      maxSizeMB: 1, // Max file size in MB
      maxWidthOrHeight: 800, // Max width or height in pixels
      useWebWorker: true, // Use web workers for faster compression
    };

    try {
      const compressedFile = await imageCompression(file, options);

      const formData2 = new FormData();
      formData2.append("image", compressedFile);

      const presignedUrl = await apiFetcher("/multi-stepper/upload", "POST", { key: 'test' });
      const uploadResponse = await axios.put(presignedUrl, compressedFile, {
        headers: {
          "Content-Type": 'multipart/form-data',
        },
      });

      const objectViewUrl = presignedUrl.split('?X-Amz-Algorithm')[0];

    } catch (error) {
      console.error("Error compressing or uploading image:", error);
    }
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
  };
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "application/pdf") {
      setSelectedFile(file);
      extractTextFromPDF(file); // Call your function
    } else {
      alert("Please select a valid PDF file.");
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file && file.type === "application/pdf") {
      setSelectedFile(file);
      extractTextFromPDF(file); // Call your function
    } else {
      alert("Only PDF files are allowed.");
    }
  };

  console.log(editing)
  const handleCopyAllData = () => {
    const dataToCopy = {
      steps,
      promptInput,
    };
    const jsonString = JSON.stringify(dataToCopy, null, 2);
    navigator.clipboard
      .writeText(jsonString)
      .then(() => {
        alert("All data copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy data:", err);
        alert("Failed to copy data to clipboard.");
      });
  };

  // Paste Functionality
  const handlePasteData = () => {
    navigator.clipboard
      .readText()
      .then((text) => {
        try {
          const pastedData = JSON.parse(text);
          if (pastedData.steps && Array.isArray(pastedData.steps) && typeof pastedData.promptInput === "string") {
            setSteps(pastedData.steps);
            setPromptInput(pastedData.promptInput);
            alert("Data pasted successfully!");
          } else {
            alert("Invalid data format in clipboard. Please copy valid StepperForm data.");
          }
        } catch (err) {
          console.error("Failed to parse pasted data:", err);
          alert("Failed to parse clipboard data. Please ensure valid JSON data is copied.");
        }
      })
      .catch((err) => {
        console.error("Failed to read clipboard:", err);
        alert("Failed to read clipboard data.");
      });
  };


  const extractTextFromPDF = async (file) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = async () => {
      const typedArray = new Uint8Array(reader.result);
      const pdf = await pdfjsLib.getDocument(typedArray).promise;
      let extractedText = "";

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const textContent = await page.getTextContent();
        const pageText = textContent.items.map((item) => item.str).join(" ");
        extractedText += pageText + "\n";
      }
      setPromptInput((prev) => prev ? `${prev}\n${extractedText}` : extractedText);
    };
  };

  const handleAddAccordion = () => {
    Setediting(false);
    setEditingIndex(null);
    setOriginalStepData(null);
    setIsYes(false)
    for (let tableIndex = 0; tableIndex < steps.length; tableIndex++) {
      const tableData = steps[tableIndex]?.boardData;
      if (tableData && tableData.length > 0) {
        const lastSentence = tableData[tableData.length - 1]; // Get the last sentence
        if (["Summary Script", "Final Script"].includes(steps[tableIndex]?.category)) {
          continue;
        }
        // Check if buttonText exists for the last sentence
        // if (!lastSentence?.notepadData?.buttonText || lastSentence.notepadData.buttonText.trim() === "") {
        //   alert(`Please add Button Text for the last sentence in Table of ${steps[tableIndex].title} before adding a new step.`);
        //   return; // Stop the execution if validation fails
        // }
      }
    }
    setSteps((prev) => [
      ...prev,
      {
        number: prev.length + 1,
        title: "",
        script: "",
        placeholder: "Enter step title",
        submitted: false,
        boardData: [],

      },
    ]);
    // setOriginalStepData(steps[steps.length-1])
    // setIsYes(!isYes);
  };

  // useEffect(() => {
  //   setOriginalStepData(steps[steps.length - 1])
  // }, [steps])
  console.log(originalStepData, 'boooooo')

  useEffect(() => {
    if (steps.length === 0) {
      setIsShowNext(false);
    } else {
      setIsShowNext(true);
    }

    console.log("isShowNext", isShowNext);
  }, [steps]);

  const handleToggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleTitleChange = (index, value) => {
    setSteps((prev) =>
      prev.map((step, i) => (i === index ? { ...step, title: value } : step))
    );
  };

  console.log(steps.submitted, 'submitted')

  // function splitSentences(text) {
  //   // Regex to match sentence-ending punctuation (., !, ?) while respecting abbreviations and numbers ending with a decimal point
  //   const sentenceRegex =
  //     /(?<!\b(?:Mr.|Mrs|Ms|Dr|St|Mt|Jr|Sr|Prof|Capt|Lt|Col|Gen|Rev|Hon|Adm|Pres|Gov|Maj|Sgt|etc)\.)(?<!\b(?:\d{1,3}(?:,\d{3})*(?:\.\d+)?))([.!?])\s*(?=[A-Za-z]|$)/g;

  //   const sentences = [];
  //   let lastIndex = 0;

  //   // Use regex to iterate over matches
  //   text.replace(sentenceRegex, (match, punctuation, offset) => {
  //     // Extract the sentence up to the matched punctuation
  //     const sentence = text.slice(lastIndex, offset + 1).trim();
  //     if (sentence) {
  //       sentences.push(sentence);
  //     }
  //     lastIndex = offset + 1; // Update starting point for next slice
  //     return match;
  //   });

  //   // Add any remaining text as the last sentence
  //   const remainingText = text.slice(lastIndex).trim();
  //   if (remainingText) {
  //     sentences.push(remainingText);
  //   }

  //   return sentences;
  // }
  function splitSentences(text) {
    // Regex to match sentence-ending punctuation (., !, ?) followed by spaces
    const sentenceRegex = /([.!?])\s+/g;

    const sentences = [];
    let lastIndex = 0;

    // Iterate over the matches to split sentences
    text.replace(sentenceRegex, (match, punctuation, offset) => {
      // Extract the sentence up to the matched punctuation and trim leading/trailing spaces
      const sentence = text.slice(lastIndex, offset + punctuation.length).trim();

      if (sentence) {
        // If the sentence is shorter than 15 characters, don't split
        if (sentence.length < 15) {
          if (sentences.length > 0) {
            // Add the sentence to the last one (concatenation)
            sentences[sentences.length - 1] += " " + sentence;
          } else {
            sentences.push(sentence);
          }
        } else {
          sentences.push(sentence);
        }
      }
      lastIndex = offset + punctuation.length; // Update the last index for the next slice
      return match;
    });

    // Handle any remaining text as the last sentence
    const remainingText = text.slice(lastIndex).trim();
    if (remainingText) {
      sentences.push(remainingText);
    }

    return sentences;
  }

  // console.log(buttonText, "buttonText")
  // console.log(buttonText, 'buttontete')
  // console.log(price, priceTax, 'priceee')

  const handleScriptSubmit = async (index) => {
    console.log("steps", steps);

    const step = steps[index];
    console.log(step)
    const script = step.script;
    console.log(step.boardData,'sosmssmsmsm')
    // Split the script into sentences and filter out empty ones
    const sentences = splitSentences(script).filter((sentence) => sentence.trim() !== "");

    const newSentences = !editing
      ? sentences.map((sentence) => ({
        sentence: sentence.trim(),
        notepadData: null,
        boardDataAdded: false,
      }))

      : sentences.map((sentence, i) => {
        const existingData = step.boardData?.[i];
        console.log(existingData,'existinfdatatatta')
        return {
          sentence: sentence.trim(),
          notepadData: existingData?.notepadData || null,
          boardDataAdded: existingData?.boardDataAdded || false, //if we dont have boarddataadded in edit case fallback it false as we added a new line
        };
      });
      
      console.log('steps',steps)
    // Convert the steps array into the required format
    const scriptData = convertData(steps);
    console.log("SCRIPT DATA", scriptData);

    // Validate the required fields and collect missing fields
    const missingFields = [];

    if (!scriptData.steps[index].script?.trim()) {
      missingFields.push("Script");
    }
    if (!scriptData.steps[index].stepTitle?.trim()) {
      missingFields.push("Title");
    }
    if (!scriptData.steps[index].type?.trim()) {
      missingFields.push("Category");
    }

    // Corrected condition for buttonText validation
    if (scriptData.steps[index].type === "Product Script" || scriptData.steps[index].type === "Intro") {
      if (!scriptData.steps[index].buttonText?.trim()) {
        missingFields.push("Button Text");
      }
    }

    // Additional validation for Product Script
    if (scriptData.steps[index].type === "Product Script") {
      if (!scriptData.steps[index].price) {
        missingFields.push("Price");
      }
      if (!scriptData.steps[index].reSelection?.trim()) {
        missingFields.push("Re-Selection Script");
      }
      if (!scriptData.steps[index].unSelection?.trim()) {
        missingFields.push("Unselection Script");
      }
    }

    // If there are missing fields, show an alert with the list of missing fields
    if (missingFields.length > 0) {
      alert(`Please fill the following required fields:\n\n- ${missingFields.join("\n- ")}`);
      return; // Exit early if validation fails
    }

    // Update the steps array with the new data ONLY AFTER validation passes
    setSteps((prev) =>
      prev.map((step, i) =>
        i === index
          ? { ...step, submitted: true, boardData: newSentences }
          : step
      )
    );

    try {
      // If multiStepProcessId exists, update the existing process
      if (multiStepProcessId) {
        const updatedresponse = await apiFetcher(`/multi-stepper/${multiStepProcessId}`, "PATCH", scriptData);
        console.log("updated", updatedresponse);
      } else {
        // If multiStepProcessId does not exist, create a new process
        const response = await apiFetcher("/multi-stepper/", "POST", scriptData);
        console.log("response", response);

        // If the response contains an _id, update the state and save the ID
        if (response && response._id) {
          dispatch(updatemultiStepProcessId({ multiStepProcessId: response._id }));
          savemultiStepProcessId(response?._id);
        }
      }
    } catch (error) {
      // Log any errors that occur during the API call
      console.error("Error during final submit:", error);
    }
    Setediting(false);
    setEditingIndex(null);
    setOriginalStepData(null);
  };

  const handleUpdate = (index) => {
    setEditingIndex(index)
    Setediting(true)
    setOriginalStepData(steps[index])// Save current step data so that it can be used if clicked cancel
    setSteps((prev) =>
      prev.map((step, i) =>
        i === index ? { ...step, submitted: false } : step
      )
    );
  };

  const handleDelete = async (index) => {
    setSteps((prev) => prev.filter((_, i) => i !== index));
    console.log("DELETE", steps.filter((_, i) => i !== index))
    const scriptData = convertData(steps.filter((_, i) => i !== index));
    console.log("SCRIPT DATA", scriptData)


    try {
      if (multiStepProcessId) {
        const updatedresponse = await apiFetcher(`/multi-stepper/${multiStepProcessId}`, "PATCH", scriptData)
        console.log('updated', updatedresponse)

      }
      // else {
      //   const response = await apiFetcher("/multi-stepper/", "POST", scriptData);

      //   console.log("response", response);

      //   if (response && response._id) {
      //     dispatch(updatemultiStepProcessId({ multiStepProcessId: response._id }));
      //     savemultiStepProcessId(response?._id)
      //   }
      // }

    } catch (error) {
      console.error("Error during final submit:", error);
    }
  };

  console.log('STEPS', steps.length === 0)
  // Step 2: Prompt Input Logic
  const handleInputChange = (e) => setPromptInput(e.target.value);
  const handleCategoryChange = (index, value) => {
    setSteps((prev) =>
      prev.map((step, i) =>
        i === index
          ? {
            ...step,
            category: value,
            unselectionScript: value === "Product Script" ? "" : undefined,
            reSelectionScript: value === "Product Script" ? "" : undefined,
            coreFeature: value === "Product Script" ? "" : undefined,
            partialFeature: value === "Product Script" ? "" : undefined
          }
          : step
      )
    );

  };

  const handleExtraTextChange = (index, field, value) => {
    setSteps((prev) =>
      prev.map((step, i) =>
        i === index
          ? {
            ...step,
            [field]: value,
          }
          : step
      )
    );
  };
  const handleDiscountChange = (index, discountPercent) => {
    setSteps((prevSteps) => {
      return prevSteps.map((step, i) => {
        if (i === index && step.category === "Summary Script") {
          return { ...step, discountPercent: discountPercent };
        }
        return step;
      });
    });
  };
  const handleToggle = () => {
    setIsYes((prev) => !prev); // Toggle the state
  };

  useEffect(() => {
    if (editing) {
      setIsYes(true);
    }
  }, [editing]); // Runs only when `editing` changes
  const convertData = (originalData) => {
    console.log('originalData', originalData);

    const steps = originalData.map((item) => {
      console.log(item, "III")
      const commonData = {
        stepTitle: item.title,
        script: item.script,
        type: item.category,
        reSelection: item.reSelectionScript,
        unSelection: item.unselectionScript,
        corsText: item.coreFeature,
        partialText: item.partialFeature,
        price: item.price,
        priceTax: item.priceTax,
        priceShow: item.priceShow,
        discountPercent: item.discountPercent,
        buttonText: item?.buttonText
      };

     
     
      const notepadContents = item.boardData
        .filter((boardItem) => boardItem.notepadData)
        .map((boardItem) => ({
          heading: boardItem.notepadData?.heading,
          subHeading: boardItem.notepadData?.subHeading,
          sentence: boardItem.notepadData?.content,
          isButton: boardItem?.notepadData?.isButton,
          buttonText: boardItem?.notepadData?.buttonText,
          images: boardItem.notepadData?.images?.map((img) => ({
            text: img.imgTitle,
            image: img.image,
          })),
          key: boardItem?.sentence,
          boardDataAdded: boardItem?.boardDataAdded
        }));

      return {
        ...commonData,
        notepadContents,
      };
    });

    return {
      steps, // Array of all steps with the desired structure
      aiPrompt: promptInput,
      dealershipId: user?.dealershipId?._id,
    };
  };

  console.log('STEPSSSSSS', steps)

  const handleFinalSubmit = async () => {
    console.log('finalsubmitme',steps)
    setSubmitting(true)
    const scriptData = convertData(steps);
    console.log("SCRIPT DATA", scriptData)
    try {
      if (multiStepProcessId) {
        const updatedresponse = await apiFetcher(`/multi-stepper/${multiStepProcessId}`, "PATCH", scriptData)
        console.log('updated', updatedresponse)
      }
      else {
        const response = await apiFetcher("/multi-stepper/", "POST", scriptData);
        console.log("response", response);
        if (response && response._id) {
          dispatch(updatemultiStepProcessId({ multiStepProcessId: response._id }));
          savemultiStepProcessId(response?._id)
        }
      }
    } catch (error) {
      console.error("Error during final submit:", error);
    }
    finally {
      setSubmitting(false)
    }
  };

  const handleContextMenu = (e, index) => {
    e.preventDefault();
    setContextMenu({
      visible: true,
      x: e.clientX,
      y: e.clientY,
      index: index,
    });
  }

  // useEffect(() => {
  //   if (lastStepref.current === 1) {
  //     lastStepItem = steps[steps.length - 1]
  //   }
  //   lastStepref.current += 1
  // }, [steps])

  useEffect(() => {
    const handleClickOutside = () => {
      if (contextMenu.visible) {
        setContextMenu((prev) => ({ ...prev, visible: false }));
      }
    };
    window.addEventListener('click', handleClickOutside);
    return () => window.removeEventListener('click', handleClickOutside);
  }, [contextMenu.visible]);


  const stepLabels = [
    { label: "Manage Steps" },
    { label: "Manage Prompt" },
    // { label: "Review Avatar" },
  ];

  const menuVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1 },
  }

  const handleCancel = (index) => {
    if (editing) {
      if (editingIndex !== null && originalStepData) {
        setSteps((prevsteps) => {
          return prevsteps.map((step, index) => {
            if (editingIndex === index) {
              return { ...originalStepData, submitted: true }
            }
            else {
              return step
            }
          })
        })
      }
    }
    else {
      let lastStepItem = steps?.[steps.length - 1];
      console.log(lastStepItem, 'lastetetetet');
      let clearedStepItem = Object.keys(lastStepItem).reduce((acc, key) => {
        let value = lastStepItem[key];

        if (key === "category") {
          acc[key] = value
        }
        else if (typeof value === "string") acc[key] = "";
        else if (typeof value === "number") acc[key] = value
        else if (typeof value === "boolean") acc[key] = false;
        else if (Array.isArray(value)) acc[key] = [];
        else if (typeof value === "object" && value !== null) acc[key] = {};
        else acc[key] = null; // Default case for other types

        return acc;
      }, {});
      setSteps((prevsteps) => {
        return prevsteps.map((step, i) => {
          if (i === index) {
            return clearedStepItem;
          } else {
            return step
          }
        })
      })
      //setIsYes(false)//additionally make the price toggle also false and reset it
    }
    Setediting(false)
    setEditingIndex(null)
    setOriginalStepData(null)
  }

  console.log(isYes, 'isesjsssyessss')
  console.log(editing, 'editing');


  const stopPropagation = (e) => {
    e.stopPropagation();
  };
  
  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <TailSpin height="80" width="80" color="#4fa94d" ariaLabel="loading" />
      </div>
    );
  }


  return (
    
    <div className={styles.container}>
      {/* Stepper Component */}
      <div className={styles.stepperContainer}>
        <Stepper 
        steps={stepLabels} 
        activeStep={currentStep - 1} 
        />
        <div className={styles.labelsContainer}>
          {stepLabels.map((e, index) => (
            <p key={index} className={styles.stepLabel}>{e.label}</p>
          ))}
        </div>
      </div>


      {/* Step 1: StepperForm */}
      {currentStep === 1 && (
        <div>
          <header className={styles.header}>
            {/* Copy and Paste Buttons */}
            <div className="flex justify-end mb-4">
              {steps.length > 0 && (
                <button
                onClick={handleCopyAllData}
                className="flex items-center gap-2 px-4 py-2 text-white rounded-lg shadow-md mr-2"
                style={{background:delaershipTheme}}
              >
                <DocumentDuplicateIcon className="w-5 h-5" /> Copy All Data
              </button>)}
              <button
                onClick={handlePasteData}
                className="flex items-center gap-2 px-4 py-2 text-white rounded-lg shadow-md "
                style={{background:delaershipTheme}}
             >
                <ClipboardIcon className="w-5 h-5" /> Paste Data
              </button>
            </div>
          </header>

          <div className="flex flex-col items-center gap-4 p-4 bg-gray-50 rounded-2xl shadow-md w-full max-w-sm mx-auto">
            <label
              htmlFor="logo-upload"
              className="flex flex-col items-center justify-center w-full h-40 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:bg-gray-100"
            >
              {selectedImage ? (
                <img
                  src={selectedImage.preview}
                  alt="Preview"
                  className="w-full h-full object-contain rounded-lg"
                />
              ) : (
                <div className="flex flex-col items-center">
                  <p className="text-sm text-gray-600">Click to upload a logo</p>
                  <p className="text-xs text-gray-400">Supports PNG, JPG, JPEG</p>
                </div>
              )}
              <input
                id="logo-upload"
                type="file"
                accept="image/png, image/jpeg"
                onChange={handleImageChange}
                className="hidden"
              />
            </label>

            {selectedImage && (
              <button
                onClick={handleRemoveImage}
                className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
              >
                Remove Image
              </button>
            )}
          </div>
          <div className="flex justify-center items-center mt-4">
            <button
              onClick={handleAddAccordion}
              className="flex items-center gap-2 px-4 py-2 text-white rounded-lg shadow-md  transition-all"
            style={{background:delaershipTheme}}
            >
              Add Step <FaPlus />
            </button>
          </div>
          <div className={styles.accordion}>
            {steps.map((step, index) => (
              <div key={index} onContextMenu={(e) => handleContextMenu(e, index)} className={styles.accordionItem}>
                <div
                  className={styles.accordionHeader}
                  onClick={() => handleToggleAccordion(index)}
                >

                  <input
                    type="text"
                    value={step.title}
                    maxLength={25}
                    onChange={(e) => handleTitleChange(index, e.target.value)}
                    className={styles.accordionTitleInput}
                    placeholder={step.placeholder}
                    onClick={stopPropagation}
                  />
                  <div className={styles.accordionSelectBody}>
                    <select
                      value={step.category}
                      onChange={(e) =>
                        handleCategoryChange(index, e.target.value)
                      }
                      className={styles.categoryDropdown}
                      onClick={stopPropagation}
                    >
                      <option value="">Select Category</option>
                      {categories.map((category) => (
                        <option key={category} value={category}>
                          {category}
                        </option>
                      ))}
                    </select>

                    <span className={styles.accordionToggle}
                    >
                      {activeIndex === index ? (
                        <FaChevronUp />
                      ) : (
                        <FaChevronDown />
                      )}
                    </span>
                  </div>
                </div>
                {activeIndex === index && (
                  <div className={styles.accordionBody}>



                    {!step.submitted ? (
                      <>
                        <textarea
                          placeholder="Enter script..."
                          value={step.script}
                          onChange={(e) =>
                            setSteps((prev) =>
                              prev.map((item, i) =>
                                i === index
                                  ? { ...item, script: e.target.value }
                                  : item
                              )
                            )
                          }
                          className={styles.textarea}
                        ></textarea>

                        {!["Summary Script", "Final Script"].includes(step.category) && (
                          <>
                            <label className={styles.lable}>Enter the Button text </label>
                            <input
                              placeholder="Enter Button text"
                              value={step.buttonText || ""}
                              required
                              onChange={(e) =>
                                handleExtraTextChange(
                                  index,
                                  "buttonText",
                                  e.target.value
                                )
                              }
                              // onChange={(event) => setButtonText(event.target.value)}
                              className={styles.btnText}
                            />
                          </>
                        )}

                        {/* Conditional Text Areas for Product Script */}
                        {step.category === "Product Script" && (
                          <>
                           <br/> <label className={styles.lable}>Unselection Script</label>
                            <textarea
                              placeholder="Get Unselection Script"
                              value={step.unselectionScript || ""}
                              onChange={(e) =>
                                handleExtraTextChange(
                                  index,
                                  "unselectionScript",
                                  e.target.value
                                )
                              }
                              className={styles.textarea}
                            ></textarea>


                            <label className={styles.lable}>Reselection Script</label>
                            <textarea
                              placeholder="Re-selection Script"
                              value={step.reSelectionScript || ""}
                              onChange={(e) =>
                                handleExtraTextChange(
                                  index,
                                  "reSelectionScript",
                                  e.target.value
                                )
                              }
                              className={styles.textarea}
                            ></textarea>

                            {/* <div style={{ textAlign: "left", margin: "10px 0" }}>
                              <label>Do you want to show individual price ?</label> <br />
                              <label className={styles.switch}>
                                <input
                                  type="checkbox"
                                  checked={isYes}
                                  onChange={handleToggle}
                                />
                                <span className={styles.slider}></span>
                              </label>

                              {isYes && (
                                <div style={{ display: 'flex', gap: '15px' }}>
                                  <div style={{ display: 'flex', flexDirection: "column" }}>
                                    <label>Price</label>
                                    <input
                                      type="number"
                                      placeholder="Enter Price"
                                      value={step.price || 0}
                                      onChange={(e) =>
                                        handleExtraTextChange(
                                          index,
                                          "price",
                                          e.target.value
                                        )
                                      }
                                      // onChange={(e) => setPrice(e.target.value)}
                                      className={styles.priceInput}
                                    />
                                  </div>
                                  <div style={{ display: 'flex', flexDirection: "column" }}>
                                    <label>Price Tax</label>
                                    <input
                                      type="number"
                                      placeholder="Enter Price Tax"
                                      value={step.priceTax || ""}
                                      onChange={(e) =>
                                        handleExtraTextChange(
                                          index,
                                          "priceTax",
                                          e.target.value
                                        )
                                      }
                                      // onChange={(e) => setPriceTax(e.target.value)}
                                      className={styles.priceInput}
                                    />
                                  </div>
                                </div>
                              )}
                            </div> */}
                            <label className={styles.lable}>Factory Maintenance Coverage</label>
                            <textarea
                              //     maxLength={50}
                              placeholder="Factory Maintenance Coverage"
                              className={styles.textarea}
                              value={step.coreFeature || ""}
                              onChange={(e) =>
                                handleExtraTextChange(
                                  index,
                                  "coreFeature",
                                  e.target.value
                                )
                              }
                            ></textarea>
                            <label className={styles.lable}>Factory Warranty Coverage</label>
                            <textarea
                              //   maxLength={50}
                              placeholder="Factory Warranty Coverage"
                              className={styles.textarea}
                              value={step.partialFeature || ""}
                              onChange={(e) =>
                                handleExtraTextChange(
                                  index,
                                  "partialFeature",
                                  e.target.value
                                )
                              }
                            ></textarea>
                          </>
                        )}
                        {step.category === "Summary Script" && (
                          <div>
                            <label className={styles.lable}>Enter Discount Percentage:</label>
                            <input
                              type="number"
                              value={step.discountPercent || 0}  // Show the stored discount value if present
                              onChange={(e) => handleDiscountChange(index, e.target.value)}  // Update the steps array when discount changes
                              placeholder="Enter discount percentage"
                              className={styles.inputField}
                            />
                          </div>
                        )}

                        <div className={styles.addButtonContainer}>
                          <button
                            onClick={() => handleScriptSubmit(index)}
                            className={styles.submitButton}
                          >
                            Submit
                          </button>

                          {
                            <button
                              onClick={() => handleCancel(index)}
                              className={styles.cancelBtn}
                            >
                              cancel
                            </button>}
                        </div>
                      </>
                    ) : (
                      <div>
                        <div className={styles.scriptText}> <label>Script:</label> <br />{step.script}</div>
                        {/* Display Submitted Text Areas for Product Script */}
                        {step.category === "Product Script" && (
                          <>
                            <div className={styles.scriptText}>
                              <label>Unselection Script:</label> <br /> {step.unselectionScript}
                            </div>
                            <div className={styles.scriptText}>
                              <label>Re-selection Script:</label> <br /> {step.reSelectionScript}</div>
                            <div className={styles.scriptText}>
                              <label>Factory Maintenance Coverage:</label> <br /> {step.coreFeature}</div>
                            <div className={styles.scriptText}>
                              <label>Factory Warranty Coverage:</label> <br /> {step.partialFeature}</div>
                            {/* <div className={styles.scriptText}>
                              <label>Price:</label> <br /> {step.price}</div>
                            <div className={styles.scriptText}>
                              <label>Price Tax:</label> <br /> {step.priceTax}</div> */}
                          </>
                        )}
                        {!["Summary Script", "Final Script"].includes(step.category) && (
                          <>
                            <div className={styles.btnText}>
                              <label>Button Text:</label> <br /> {step.buttonText}
                            </div>
                          </>
                        )}
                        {step.category === "Summary Script" && (
                          <>
                            <div className={styles.scriptText}>
                              <label>Discount:</label> <br /> {step.discountPercent}
                            </div>
                          </>
                        )}
                        <div className={styles.steperbuttonContainer}>
                          <button
                            onClick={() => handleUpdate(index)}
                            className={styles.updateButton}
                          >

                            <FaEdit />
                          </button>
                          <button
                            onClick={() => handleDelete(index)}
                            className={styles.deleteButton}
                          >
                            <MdDelete />
                          </button>
                        </div>

                        {steps[activeIndex]?.category === "Summary Script" || steps[activeIndex]?.category === "Final Script" ? (null) :
                          (
                            <TableComponent
                              activeIndex={activeIndex}
                              currentIndex={currentIndex}
                              setCurrentIndex={setCurrentIndex}
                              onActionClick={index + 1}
                              formData={formData}
                              setFormData={setFormData}
                              selectedSentence={selectedSentence}
                              setSelectedSentence={setSelectedSentence}
                              tableIndex={tableIndex}
                              setTableIndex={setTableIndex}
                              steps={steps}
                              setSteps={setSteps}
                              editIndex={editIndex}
                              setEditIndex={setEditIndex}
                            />
                          )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}

            <AnimatePresence>
              {contextMenu.visible && (
                <motion.div

                  className="fixed z-50 w-56 bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden"
                  style={{ top: contextMenu.y, left: contextMenu.x }}
                  initial="hidden"
                  animate="visible"
                  exit="hidden"
                  variants={menuVariants}
                  transition={{ duration: 0.3 }}
                >
                  <ul className="py-2">
                    <li className="flex items-center justify-between">
                      <button
                        onClick={() => {
                          handleDelete(contextMenu.index)
                          setContextMenu((prev) => ({ ...prev, visible: false }));
                        }}
                        className="w-full text-left px-4 py-2 flex items-center space-x-3 hover:bg-indigo-50 focus:outline-none focus:bg-indigo-50 transition-colors duration-150"
                      >
                        <span><TrashIcon className="w-4 h-4 text-gray-400" /></span>
                        Delete accordion
                      </button>
                    </li>
                  </ul>
                </motion.div>
              )}
            </AnimatePresence>


          </div>
          {isShowNext &&
            (
              <div className={styles.buttonContainerB}>
                <button onClick={handleNextStep} className={styles.nextButton} style={{background:delaershipTheme}}>
                <p>Manage Your Prompt</p> <MdNavigateNext />
                </button>
              </div>
            )
          }
        </div>
      )}

      {/* Step 2: Input Prompt */}
      {currentStep === 2 && (
        <div>
          <header className={styles.header}>
            {/* <h2>Step 2: Enter Prompt</h2> */}
            {/* <h2>Enter a text prompt for the Avatar in Step 3.</h2> */}
          </header>
          <div className="w-100 flex justify-center">
            <div className="flex flex-col items-center justify-end p-6 bg-gray-100 rounded-xl shadow-md w-96 mb-3">
              <label
                htmlFor="pdf-upload"
                className="cursor-pointer bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition"
              style={{background:delaershipTheme}}
              >
                Choose a PDF
              </label>
              <input
                id="pdf-upload"
                type="file"
                accept="application/pdf"
                className="hidden"
                onChange={handleFileChange}
              />

              <div
                className="mt-4 p-6 border-2 border-dashed border-gray-400 rounded-lg text-center bg-white w-full"
                onDragOver={handleDragOver}
                onDrop={handleDrop}
              >
                <p className="text-gray-500">Drag & Drop your PDF here</p>
              </div>

              {selectedFile && (
                <div className="mt-4 bg-gray-200 p-3 rounded-lg w-full text-center">
                  <p className="text-gray-700">{selectedFile.name}</p>
                </div>
              )}
            </div>
          </div>
          <textarea
            rows="10"
            cols="50"
            value={promptInput}
            onChange={handleInputChange}
            placeholder="Type your prompt here"
            style={{ width: "100%", height: "450px" }}
            className={styles.textarea}
          />
          <div className={styles.buttonContainerB}>
            <button onClick={handlePrevStep} style={{background:delaershipTheme}} className={styles.prevButton}>
              <GrFormPrevious /><p>Back</p>
            </button>
            <button disabled={submitting} onClick={handleFinalSubmit} style={{background:delaershipTheme}} className={styles.submitButton}>
              {submitting ? "Submitting..." : "Final Submit"}
            </button>
          </div>
        </div>
      )}

      {/* Step 3: Avatar */}
      {/* {currentStep === 3 && (
        <div>
          <header className={styles.header}>
            <h2>Step 3: Avatar</h2>
            
          </header>
          <Avatar userPrompt={promptInput} />
          <div className={styles.buttonContainerB}>
            <button onClick={handlePrevStep} className={styles.prevButton}>
              <GrFormPrevious />
            </button>
       
          </div>
        </div>
      )} */}
    </div>
  );
};

export default StepperForm;
